// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oAqzh","title":"styles_title__204gT"};